import { Suspense } from 'react';
import {
  Await,
  matchPath,
  useLoaderData,
  useNavigate,
  useNavigation,
  useParams,
} from 'react-router-dom';
import { Network } from '@kattana-io/common';
import Text from '../../atoms/Text';
import { PanelMobile } from '../MainPage/mobile';
import Header from '../MainPage/Header';
import Chain from './Chain';
import ChainMobile from './mobile/Chain';
import Loader from '../../components/common/Loader';
import useDevice from '../MainPage/useMobileDetect';
import { chainPageLoaderDataType } from '../loaders/chainPageLoader';
import { chainLogosMapping } from './helpers';

const ChainPage = () => {
  const navigation = useNavigation();
  const navigate = useNavigate();
  const params = useParams();
  const { chain } = useLoaderData() as Record<string, unknown>;
  const { isMobile } = useDevice();

  const isNavigationOnCurrentRoute = matchPath(
    '/:lang/chain/:chain',
    navigation.location?.pathname ?? ''
  );

  const loading = navigation.state === 'loading' && isNavigationOnCurrentRoute;

  const network = Network.fromChain(params.chain || '');
  const slug = params.chain || '';
  const title = network?.getName() || slug;
  const chainLogo = slug ? (chainLogosMapping as any)[slug] || '' : '';

  return (
    <Suspense
      fallback={
        <div className='centrify'>
          <Loader />
        </div>
      }
    >
      <Await resolve={chain} errorElement={<div>Error Loading</div>}>
        {(data: chainPageLoaderDataType) => {
          if (!data) {
            if (isMobile) {
              return (
                <PanelMobile title='Token' onBack={() => navigate(-1)}>
                  <div className='centrify' style={{ height: 300 }}>
                    <Text size={20} className='text--grey-200'>
                      No data...
                    </Text>
                  </div>
                </PanelMobile>
              );
            }

            return (
              <>
                <Header />
                <div className='centrify' style={{ height: 600 }}>
                  <Text size={24} className='text--grey-200'>
                    No data...
                  </Text>
                </div>
              </>
            );
          }

          if (isMobile) {
            return (
              <PanelMobile
                title={`${params.chain} chain`}
                onBack={() => navigate(-1)}
              >
                {loading && (
                  <div className='main_page__backdrop'>
                    <Loader className='main_page__backdrop__loader' />
                  </div>
                )}
                <ChainMobile
                  chain={data}
                  title={title}
                  slug={slug}
                  logo={chainLogo}
                />
              </PanelMobile>
            );
          }

          return (
            <>
              {loading && (
                <div className='main_page__backdrop'>
                  <Loader className='main_page__backdrop__loader' />
                </div>
              )}
              <Chain chain={data} title={title} slug={slug} logo={chainLogo} />
            </>
          );
        }}
      </Await>
    </Suspense>
  );
};

export default ChainPage;
